import { render, staticRenderFns } from "./psp-settlements.vue?vue&type=template&id=5f826458&scoped=true&"
import script from "./psp-settlements.vue?vue&type=script&lang=js&"
export * from "./psp-settlements.vue?vue&type=script&lang=js&"
import style0 from "./psp-settlements.vue?vue&type=style&index=0&id=5f826458&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f826458",
  null
  
)

export default component.exports